<template>
  <Wrapper @click.stop.self.prevent :ref="`wrapper`" class="wrapper wrapper-line-separate-tool">
    <!-- <div class="detail center-hv" v-if="resizing">
      W: {{ component.style.width }}, H: {{ component.style.height }}
    </div> -->
    <!-- <div
      @mouseover="initMouseOver(direction ? 's' : 't')"
      :ref="direction ? 's' : 't'"
      class="resize-dot"
      :class="{ start: direction, top: !direction }"
    ></div>
    <div
      @mouseover="initMouseOver(direction ? 'e' : 'b')"
      :ref="direction ? 'e' : 'b'"
      class="resize-dot"
      :class="{ end: direction, bottom: !direction }"
    ></div> -->
    <ResizeDot 
      v-if="!isPreview && detectDevice == 'desktop'"
      :ref="'resizeDot'"
      :tools="direction ? ['left', 'right'] : ['top', 'bottom']"
      :details="direction ? 'width' : 'height'"
      :detailPosition="'bottom'"
      :resizeMode="resizeMode"
      :minWidth="minWidth"
      :maxWidth="maxWidth"
      @focus="onFocus"
      @input="onInput"
      @change="onChange" 
      @blur="onBlur" 
    />
  </Wrapper>
</template>

<script>
import { mapGetters } from "vuex";
import { Wrapper } from "./ImageResize.styled";
import ResizeDot from "@components/dynamic/widget/Share/ResizeDot";

export default {
  props: ["component"],
  components: {
    Wrapper,
    ResizeDot,
  },
  computed: {
    ...mapGetters({
      detectDevice: "detectDevice",
      isPreview: "designIframe/preview",
      mode: "designIframe/mode",
      components: "designIframe/metadata/components",
    }),
    componentId() {
      return this.component.id;
    },
    direction() {
      return this.component.style.direction === "horizontal";
    },
    positionX() {
      return this.component && this.component.style.alignX;
    },
    resizeMode() {
      return this.positionX == 'center' ? 'mirror' : 'normal';
    },
    maxWidth() {
      const cell = this.$helper.component.getComponentParantCell(this.components, this.component.id);
      const cell_w = document.getElementById(`comp-${cell.id}`).getBoundingClientRect().width;
      const cell_pl = cell.style.paddingLeft;
      const cell_pr = cell.style.paddingRight;
      return parseInt(cell_w) - parseInt(cell_pl) - parseInt(cell_pr);
    },
  },
  data() {
    return {
      ratio: 1,
      resizeDirection: undefined,
      resizing: false,
      minWidth : 15
    };
  },
  mounted () {
    document.addEventListener("mouseleave", this.detectOutOfFrame, { passive: true });
  },
  methods: {
    onFocus() {
      this.setMode('temporary');
    },
    onInput({ value }) {
      if (this.direction) {
        this.component.style.widthType = 'fixed';
        this.component.style.width = value.width;
      } else {
        this.component.style.height = value.height;
      }
      this.$store.dispatch("designIframe/frame/reRenderFrame");
    },
    onChange() {
      this.snap();
      this.applyTemp();
    },
    onBlur() {
      this.setMode(undefined);
    },
    setMode(mode) {
      this.$store.dispatch("design/setMode", { mode });
      this.$store.dispatch("designIframe/setMode", { mode });
    },
    applyTemp() {
      if (this.mode == "temporary") {
        this.$store.dispatch("design/snapshot/applyTemp");
      }
    },
    snap() {
      this.$store.dispatch("designIframe/snapshot/genSnapshot");
    },
    initMouseOver(ref) {
      this.dragElement(ref);
    },
    dragElement(ref) {
      if (this.$refs[ref]) {
        this.resizeDirection = ref;
        this.$refs[ref].onmousedown = this.dragMouseDown;
      }
    },
    dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      this.resizing = true;
      document.onmouseup = this.closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = this.elementDrag;
    },

    elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      const position_wrapper = document.getElementById(
        `comp-${this.componentId}`
      );
      this.height = position_wrapper.getBoundingClientRect().offsetHeight;
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      let total = 0;
      switch (this.resizeDirection) {
        case "s": {
            const space = parseInt(position_wrapper.getBoundingClientRect().left - this.pos3)
            let area = this.component.style.width + space;
            total = area > 15 ? area : 15;
            this.component.style.width = total;
          break;
        }
        case "e": {
            const space = this.pos3 - parseInt(position_wrapper.getBoundingClientRect().right)
            let area = this.component.style.width + space;
            total = area > 15 ? area : 15;
            this.component.style.width = total;
          break;
        }
        case "t": {
          const space = position_wrapper.getBoundingClientRect().top - this.pos4;
          total = this.component.style.height + space;
          total = total < 0 ? 5 : total;
          this.component.style.height = total;
          break;
        }
        case "b": {
          const space = this.pos4 - position_wrapper.getBoundingClientRect().bottom;
          total = this.component.style.height + space;
          total = total < 0 ? 5 : total;
          this.component.style.height = total;
          break;
        }
        default:
          break;
      }

      this.$emit("callbackResize");
    },

    closeDragElement() {
      // stop moving when mouse button is released:
      document.onmouseup = null;
      document.onmousemove = null;
      this.resizing = false;
      this.$store.dispatch("designIframe/snapshot/genSnapshot");
    },
    detectOutOfFrame(e) {
      if(e.clientY <= 0 || e.clientX <= 0 || (e.clientX >= window.innerWidth || e.clientY >= window.innerHeight))
      {
        this.closeDragElement()
      }
    },
  },
};
</script>

<style>
.resize-dot {
  transform: translate(-50%);
}
</style>